/**
 * mockData -- de-mocked stub
 *
 * Per project anti-mocks policy, the previous synthesized mock generators
 * have been removed. These stubs return empty/safe defaults so that pages
 * compile and render without fabricated data. Pages should populate their
 * state from real API responses (REST or WebSocket subscriptions) at
 * runtime.
 *
 * If a page genuinely needs seed/sample data for a "no data yet" view,
 * that should come from the backend (via an empty-state contract), not
 * from the client.
 */

// Generic minimal shapes -- callers narrow these via their own type imports.
export function generateMockMonitoringData(): {
  timeSeries: never[];
  services: never[];
} {
  return { timeSeries: [], services: [] };
}

export function generateMockConsensusData(): {
  nodes: never[];
  events: never[];
  metrics: {
    totalElections: number;
    failedElections: number;
    averageElectionTime: number;
    throughput: number;
    electionTimeout: number;
    heartbeatInterval: number;
    averageCommitLatency: number;
  };
} {
  return {
    nodes: [],
    events: [],
    metrics: {
      totalElections: 0,
      failedElections: 0,
      averageElectionTime: 0,
      throughput: 0,
      electionTimeout: 0,
      heartbeatInterval: 0,
      averageCommitLatency: 0,
    },
  };
}

export function generateMockManagementNodes(): never[] {
  return [];
}

export function generateMockNetworkData(): {
  nodes: never[];
  connections: never[];
  geoNodes: never[];
  geoConnections: never[];
  partitions: never[];
  bottlenecks: never[];
  messageFlows: never[];
  healthData: never[];
  latencyHeatmap: never[];
  bandwidthFlows: never[];
  strategies: never[];
  discoveryEvents: never[];
  peerConnections: never[];
  loadBalancing: never[];
} {
  return {
    nodes: [],
    connections: [],
    geoNodes: [],
    geoConnections: [],
    partitions: [],
    bottlenecks: [],
    messageFlows: [],
    healthData: [],
    latencyHeatmap: [],
    bandwidthFlows: [],
    strategies: [],
    discoveryEvents: [],
    peerConnections: [],
    loadBalancing: [],
  };
}
